/**
 * Single source of truth for “import offer” → route and labels.
 * Keeps LocationCard / dialogs aligned with backend offer type codes.
 */
export const OFFER_IMPORT_TYPES = [
    { name: "IPA", type: 20, routeName: "OfferIPA" },
    { name: "VMC", type: 3, routeName: "OfferVMC" },
    { name: "Simplă", type: 4, routeName: "OfferSimple" },
    { name: "Sanitare", type: 2, routeName: "OfferPlumbing" },
    { name: "Servicii", type: 13, routeName: "OfferServices" },
    { name: "C. T. și COLOANE", type: 5, routeName: "OfferTechnicalRoom" },
    { name: "Tavan", type: 6, routeName: "OfferCeiling" },
    { name: "Pereți", type: 7, routeName: "OfferWalls" },
    { name: "Automatizare", type: 8, routeName: "OfferAutomation" },
    { name: "Ventiloconvectoare", type: 9, routeName: "OfferFanCoilUnit" },
    { name: "Canal Termic", type: 10, routeName: "OfferThermalChannel" },
    { name: "Pompe de Căldură", type: 11, routeName: "OfferPDC" },
    { name: "Aspirare", type: 12, routeName: "OfferVacuum" },
];

/** IPA + VMC: import opens sizing on a fresh location row (see product rules). */
const NEW_LOCATION_ON_IMPORT_TYPES = new Set(
    OFFER_IMPORT_TYPES.filter(({ type }) => type === 20 || type === 3).map(({ type }) => type)
);

export function getOfferImportTypeLabel(typeCode) {
    return (
        OFFER_IMPORT_TYPES.find(t => Number(t.type) === Number(typeCode))?.name ?? "-"
    );
}

export function getOfferImportRouteName(typeCode) {
    return (
        OFFER_IMPORT_TYPES.find(t => Number(t.type) === Number(typeCode))?.routeName ??
        null
    );
}

export function importOfferCreatesNewLocation(offerType) {
    return NEW_LOCATION_ON_IMPORT_TYPES.has(Number(offerType));
}
